import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "957bd5e2-a307-4b29-91eb-fffb29fe28f7",
  title: "Base Training: Pfitzinger/Latter: Up to 60 miles per week, 10-week schedule",
  raceType: "Base",
  units: "miles",
  workouts: [
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Endurance 9 miles",
      totalDistance: 9,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Endurance 11 miles",
      totalDistance: 11,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Endurance 10 miles",
      totalDistance: 10,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Endurance 10 miles",
      totalDistance: 10,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Endurance 10 miles",
      totalDistance: 10,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "General aerobic + speed 7 miles w/ 8x100m strides",
      totalDistance: 7,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Endurance 11 miles",
      totalDistance: 11,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "Lactate threshold 7 miles w/ 20 min tempo",
      totalDistance: 7,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Endurance 11 miles",
      totalDistance: 11,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "General aerobic + speed 7 miles w/ 8x100m strides",
      totalDistance: 7,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "Lactate threshold 8 miles w/ 22 min tempo",
      totalDistance: 8,
    },
    {
      description: "Endurance 14 miles",
      totalDistance: 14,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "General aerobic + speed 9 miles w/ 10x100m strides",
      totalDistance: 9,
    },
    {
      description: "Endurance 14 miles",
      totalDistance: 14,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "Lactate threshold 9 miles w/ 24 min tempo",
      totalDistance: 9,
    },
    {
      description: "Endurance 14 miles",
      totalDistance: 14,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 11 miles",
      totalDistance: 11,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description: "General aerobic + speed 10 miles w/ 10x100m strides",
      totalDistance: 10,
    },
    {
      description: "Endurance 14 miles",
      totalDistance: 14,
    },
  ]
} as BuiltInPlan;